<template>
    <main-content>
        <div class="shadow-sm rounded p-4">
            <transfer-form :form_data="form_data" :form_meta_data="form_meta_data"
                           :on_submit="transfer"></transfer-form>
        </div>
    </main-content>
</template>

<script>
    import TransferForm from './components/transfer-form'
    import mainContent from '@/components/main-content'
    import {i18n} from "@/plugins/i18n";
    import $ from "jquery";
    import {walletService} from "@/common/api.service";

    export default {
        components: {
            TransferForm,
            mainContent,
        },
        data() {
            return {
                form_data: {
                    amount: '',
                },
                form_meta_data: {
                    submit_btn_progress: false,
                    submit_btn_text: i18n.t('wallets.label.transfer'),
                },
            };
        },
        methods: {
            transfer() {
                let form = $('#submit_form');

                form.validate({
                    rules: {
                        amount: {
                            required: true,
                        },
                        destination_wallet_id: {
                            required: true,
                        },
                    }
                });

                if (!form.valid()) {
                    return;
                }

                this.form_meta_data.submit_btn_progress = true;

                let params = {
                    amount: this.form_data.amount,
                    destination_wallet_id: this.form_data.destination_wallet_id,
                };

                walletService.transferDay(params, this.$route.params.hashid).then(response => {
                    /** TODO: success */
                }).catch(({response}) => {
                    if (response.data) {
                        form.validate().showErrors(response.data.data);
                    }

                    this.showMsg(form, 'danger', response.data.message);
                }).finally(() => {
                        this.form_meta_data.submit_btn_progress = false;
                    }
                );
            },
        },
    }
</script>
